import { CommonModule } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { RichTextComment, TimelinePollResultTimelineItemType } from "@teammood/timeline";
import { PollResultService } from "../poll-result.service";
import { LinkyModule } from "@teammood/shared/util/linky";
import { PollResultValue } from "../poll-result.type";

@Component({
    selector: 'poll-result-comments',
    templateUrl: './poll-result-comments.component.html',
    styleUrls: ['./poll-result-comments.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltipModule,
        LinkyModule
    ]
})
  export class PollResultCommentsComponent {

    @Input() commentResults: PollResultValue[];
    @Input() itemType: TimelinePollResultTimelineItemType;

    constructor(
        private pollResultService: PollResultService,
    ){}

    formatComment(comment: RichTextComment): string{
        if(comment?.htmlFormat){
            return this.pollResultService.formatPollResultGifs(comment.htmlFormat)
        }
    }
  }


